import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';

type PointsListProps = ComponentProps & {
  fields: {
    title: {
      value: string
    },
    childItems: any[]
  };
  locale: string,
  lang: string
};

const PointsList = (props: PointsListProps): JSX.Element => {

  return (
    <div className='bg-[#F2F2F2] lg:my-20 my-12'>
     <div className={`responsive py-10 ${props?.locale=="ar"?'rtl':''}`}>
        <h1 className="text-[28px] text-[#003141] font-bold animate-top-dga">{props.fields.title.value}</h1>
        <div className='mt-8'>
          {props.fields?.childItems?.map((purpose: any, index: number) => {
            return (
              <div className='flex items-baseline gap-4 my-6 animate-top-dga'>
                <span className=' min-w-[12px] min-h-[12px] bg-[#FF9619]'></span>
                <p className="text-[#5E5E5EFC] 2xl:text-[18px] text-[14px] leading-6 font-normal text-justify" key={index}>{purpose?.fields?.Point.value}</p>
              </div>
            )
          })}

        </div>

      </div>
    </div>

  );
}

export default withDatasourceCheck()<PointsListProps>(PointsList);
